<template>
  <div class="third cardsConfigNew">
    <div class="third-rea">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="searchInput">查询</el-button>
          <el-button class="btn-two" type="default" @click="resetInput">重置</el-button>
          <span class="btn-shu"></span>
          <!-- <el-button
              class="btn-four"
              type="default"
              icon="el-icon-search"
              @click="hignSearch"
              >高级检索</el-button
          >-->
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="formInline" label-width="76px" @keyup.native.enter="searchInput">
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="卡片名称" prop="cardName">
                <el-input class="item-input" :maxlength="30" v-model.trim="formInline.cardName" @keyup.enter.native="search" placeholder="请输入"></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="引用业务包">
                <el-select class="item-input" v-model="formInline.referencePackage" clearable placeholder="请选择">
                  <el-option label="全部" value></el-option>
                  <el-option v-for="(item,index) in optionsTow" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one service-list">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button class="do-btn-four" type="default" icon="el-icon-plus" @click="addPage(undefined)">批量新增</el-button>
        </div>
        <div class="do-btn-right">
          <span style="font-size:12px;color: #aeaeb4">已被用户端片引用的卡片不可删除</span>
        </div>
      </div>
      <el-table class="third-tableThree tableThree-heightOth" :data="tableData" border stripe @selection-change="handleSelectChange" row-key="otherUserId" ref="otherUserId" v-loading="loading">
        <!-- <el-table-column type="selection" width="32px" reserve-selection>
        </el-table-column>-->
        <template v-for="(item, index) in tableDataShow">
          <el-table-column v-if="item.needKeyValue" min-width="100px" :prop="item.key" :label="item.column" :key="index" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template  v-if="item.key == 'updateTime'">
                <span>{{ scope.row[item.key] | getTime }}</span>
              </template>
              <template v-if="item.key == 'isUse'">
                <span v-if="scope.row[item.key] == 1">是</span>
                <span v-if="scope.row[item.key] == 2">否</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column v-else min-width="100px" :prop="item.key" :label="item.column" :key="index" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ getlable(scope.row, item.key) }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addPage(scope.row)">编辑</el-button>
            <span class="table-middle_line"></span>
            <el-button :disabled="scope.row['isUse'] == 1" type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="ospApplicationCardConfigRemove"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    ></notice-modal>

    <new-task-modal
      class="detail-modal new-transfer-modal push-transferBody"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="addModal"
      @closeNewTask="closelable"
      @addNewTask="agreelable"
      agreeBtn="保存"
      :modalTitle="ruleForm.addModalType == 1?'新增':'编辑'"
    >
      <div slot="content">
        <el-form style="display: inline-block; width: 100%;" @validate="validateValue" :show-message="false" :model="ruleForm" :rules="rules" ref="ruleFormupgrade">
          <div class="one-list myform" v-if="ruleForm.addModalType == 1">
            <el-form-item label prop="description" style="width:100%">
              <el-button style="display:block;margin-bottom: 10px;" icon="el-icon-plus" @click="addFieldParams()" class="btn-two" type="default" :disabled="!addBtmDisable">新增</el-button>
              <template>
                <div class="one-list">
                  <div class="list-data-line" v-for="(item, index) in ruleForm.fields" :key="index">
                    <div style="display: inline-block;width: calc(100% - 40px);">
                      <div class="list-three-line" style="display: inline-block;;">
                        <el-form-item
                          label="引用业务包"
                          label-width="80px"
                          :prop="'fields.' + index + '.fieldName'"
                          :rules="{
                            required: true,
                            message: `请选择引用业务包`,
                            trigger: 'change',
                          }"
                        >
                          <el-select class="list-input" v-model="item.fieldName" placeholder="请选择" @change="updateInputType(item.fieldName,index)">
                            <el-option v-for="(item, index) in options" :key="index" :value="item.value" :label="item.label" :disabled="item.disabled" v-show="item.isShow"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="list-three-line" style="display: inline-block;">
                        <el-form-item
                          label-width="80px"
                          label="卡片名称"
                          :prop="'fields.' + index + '.displayName'"
                          :rules="[
                          {
                            required: true,
                            message: `请输入卡片名称`,
                            trigger: 'change',
                          },
                            {
                                validator(_,value, callback) {
                                    if (item.noNext) {
                                        callback(`${item.displayName}卡片名称重复，请重新输入`)
                                    } else {
                                        callback()
                                    }
                                },trigger: 'blur'
                            }
                        ]"
                        >
                          <el-input class="list-input" :maxlength="16" v-model.trim="item.displayName" placeholder="请输入" @input="item.noNext = false"></el-input>
                        </el-form-item>
                      </div>
                      <!-- <div class="list-addField-line" style="display: inline-block;">
                        <el-form-item class="addField-line-configItem">
                          <el-checkbox v-model="item.controlDisplay">用户控制线显隐</el-checkbox>
                        </el-form-item>
                      </div>-->
                    </div>
                    <div style="width: 40px" class="list-addField-delete" @click="removeFieldParams(item)">
                      <el-button icon="el-icon-minus"></el-button>
                    </div>
                  </div>
                </div>
              </template>
            </el-form-item>
          </div>
          <div v-else>
            <template>
              <div class="one-list" style="text-align: left;margin-top: 86px;">
                <el-form-item label-width="160px" label="引用业务包：" style="display:block">
                  <span style="font-size:12px">{{ ruleForm.updateTitle }}</span>
                </el-form-item>
                <el-form-item
                  label-width="160px"
                  label="卡片名称："
                  prop="cardName"
                  :rules="[
                    {
                        required: true,
                        message: `请输入卡片名称`,
                        trigger: 'blur',
                    },
                    {
                        validator(_,value, callback) {
                            if (ruleForm.noNext) {
                                callback('卡片名称重复，请重新输入')
                            } else {
                                callback()
                            }
                        },trigger: 'blur'
                    }
                  ]"
                >
                  <el-input @input="ruleForm.noNext = false" class="list-input" style="min-width: 220px;" :maxlength="16" v-model.trim="ruleForm.cardName" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </template>
          </div>
        </el-form>
      </div>
    </new-task-modal>
  </div>
</template>

  <script>
import { getStore, setStore } from "@/utils/store";

export default {
  name: "thirdThree",
  data() {
    return {
      // 新增弹框
      ruleForm: {
        noNext: false,
        fields: [{ displayName: "", fieldName: "" }],
        addModalType: 1,
        updateTitle: "",
        cardName: "",
        id:''
      },
      rules: {
        fields: [
          { required: true, message: "请输入电子证件名称", trigger: "blur" },
        ],
      },
      options: [
      ],
      optionsTow: [],
      closeonclickmodal: false, //是否开启点击空白处关闭弹窗
      addModal: false, //升级卡片弹窗
      transferBodyLoading: false,
      countNum: 1,
      //编辑

      loading: false,
      noticeSpec: "删除后不可恢复，", // 标红提示
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      pageSize: 40,
      pageIndex: 1,
      totalNum: 0, // 总数
      tableData: [],
      hignModal: false, // 高级搜索
      formInline: {
        appType: "",
        version: "",
        versionCode: "",
        updateType: "",
        updateTime: [],
        cardName: "",
        referencePackage: "",
      },
      selectArrList: [], // 批量移除
      nowSelectArr: [], // 移除数组
      isDeleteList: false, // 是否批量删除
      hignSearchRes: "", // 高级检索条件
      tableDataShow: [
        {
          column: "卡片名称",
          key: "cardName",
          needKeyValue: false,
          caseKey: "pav.app_type",
        },
        {
          column: "引用业务包",
          key: "packageName",
          needKeyValue: false,
          caseKey: "packageName",
        },
        {
          column: "用户端是否已使用",
          key: "isUse",
          needKeyValue: true,
          caseKey: "isUse",
        },
      ],
      orderConfig: "", // 字段展示和顺序需要的参数
      checked: true,
      statusData: {}, // 状态params
      delId: "", // 删除ID
    };
  },
  filters: {
    getTime(time) {
      let arr = time.split("");
      let a = arr.indexOf("T");
      arr.splice(a, 1, " ");
      return arr.join("");
    },
  },
  created() {
    const dispField = this.getSessonValue("APPVersionsManDisplayFied");
    const tableRow = this.getSessonValue("APPVersionsManSortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    //   if (tableRow) {
    //     this.tableDataShow = tableRow;
    //   } else {
    //     this.tableDataShow = this.tableRow;
    //   }
    this.getTableData(); // 获取列表
    this.businessPackageConfigList() // 获取引用业务包下拉菜单
    this.businessPackageConfigListTow()
    // this.init();
  },
  methods: {
    // 移除字段
    removeFieldParams(item) {
      this.ruleForm.fields.splice(this.ruleForm.fields.indexOf(item), 1);
      this.updateInputType();
    },
    // 新增字段
    addFieldParams() {
      let obj = {
        noNext: false,
        displayName: "",
        // controlDisplay: false,
        fieldName: "",
      };
      if (this.ruleForm.fields.length < 10) {
        this.ruleForm.fields.push(obj);
        console.log(this.ruleForm.fields);
      } else {
        // this.$message.error("最多可添加10个字段");
      }
    },
    //选择输入类型
    updateInputType(rowID,index) {
        console.log(rowID);
        const cardItem = this.options.find((val) => {
        return val.value == rowID;
        });
        this.ruleForm.fields[index].displayName = cardItem.label
        // this.ruleForm.fields[index].
    //   this.ruleForm.fields.map((item,i) => {
    //     if (item.fieldName == rowID) {

    //       item.displayName = cardItem.label;
    //     }
    //     return item;
    //   });
      this.options.map((item) => {
        item.isShow = true;
        return item;
      });
      console.log(this.ruleForm.fields);
      console.log( this.options);
      this.ruleForm.fields.forEach((val) => {
        this.options.forEach((item) => {
          if (val.fieldName == item.value && item.isManyQuote == 2) {
            item.isShow = false;
          }
        });
      });
      if (index || index == 0) {
        let item = this.options.find((item)=>{
            return item.value == rowID
        })
        this.ruleForm.fields[index].initConfig = item.initConfig
      }
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //关闭升级卡片弹窗
    closelable() {
      this.businessPackageConfigList() // 获取引用业务包下拉菜单
      this.$refs["ruleFormupgrade"].resetFields();
      this.addModal = false;
      Object.assign(this.ruleForm,this.$options.data().ruleForm)
      this.ruleForm.fields = [{ displayName: "", fieldName: "" }];
    },
    //升级卡片确定弹窗
    agreelable() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs["ruleFormupgrade"].validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            // this.transferBodyLoading = true;
            // return this.savaupgrade();
            console.log(this.ruleForm);
            const arr =  this.ruleForm.fields.map(item => item.displayName)
            // let numArr = []
            if(new Set(arr).size !== arr.length){
                let repeatArr = this.repeat(arr)
                let numArr = []
                this.ruleForm.fields.forEach((ele,i)=>{
                    repeatArr.forEach((item)=>{
                        if ( ele.displayName == item) {
                            this.ruleForm.fields[i].noNext = true
                        }
                    })
                })
                this.ruleForm.noNext = true
                this.countNum = 0
                this.$refs["ruleFormupgrade"].validate()
                // this.$message.error(`“${repeatArr[0]}”卡片名称重复，请重新输入`);
            　　console.log("有相同的元素--------Yes",repeatArr);
            } else {
                console.log("没有相同的元素------No");
                if (this.ruleForm.addModalType == 1) {
                    return this.ospApplicationCardConfigCheckReuse();
                } else {
                    return this.ospApplicationCardConfigUpdated();
                }
            }
          } else {
            return false;
          }
        });
      });
      //   this.savaupgrade();
    },
    repeat(arr) {
        var tmp = [];
        if (Array.isArray(arr)) {
            arr
            .concat()
            .sort()
            .sort(function(a, b) {
                if (a == b && tmp.indexOf(a) === -1) tmp.push(a);
            });
        }
        return tmp;
    },
    savaupgrade() {
      this.closelable();
    },
    // 保存卡片配置
    async ospApplicationCardConfigSave() {
      try {
        console.log(this.ruleForm);
        let arr = this.ruleForm.fields.map((item)=>{
            return {
                cardName: item.displayName,
                businessPackage: item.fieldName,
                initConfig: item.initConfig
            }
        })
        const {
          data: { status, result, msg },
        } = await this.$store.dispatch("ospApplicationCardConfigSave", {
            data:arr
        });
        if (status === 1000) {
          console.log("ospApplicationCardConfigSave", status, result, msg);
          this.$message.success("操作成功");
          this.closelable();
          this.getTableData();
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 检查卡片名称是否有重复
    async ospApplicationCardConfigCheckReuse() {
      try {
        console.log(this.ruleForm);
        let arr = this.ruleForm.fields.map((item)=>{
            return {
                cardName: item.displayName,
                businessPackage: item.fieldName,
                initConfig: item.initConfig
            }
        })
        const {
          data: { status, result, msg },
        } = await this.$store.dispatch("ospApplicationCardConfigCheckReuse", {
            data:arr
        });
        if (status === 1000) {
          console.log("ospApplicationCardConfigCheckReuse", status, result, msg);
          if (result.length) {
            const index = this.ruleForm.fields.findIndex(item => item.displayName === result[0])
            if (index !== -1) {
                this.ruleForm.fields[index].noNext = true
                this.countNum = 0
                this.$refs["ruleFormupgrade"].validate()
            } else {
                this.$message.error(`“${result.join(',')}”卡片名称重复，请重新输入`);
            }
          } else {
            this.ospApplicationCardConfigSave()
          }
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑
    async ospApplicationCardConfigUpdated() {
      try {
        const {
          data: { status, result, msg },
        } = await this.$store.dispatch("ospApplicationCardConfigUpdated", {
            id:this.ruleForm.id,
            cardName: this.ruleForm.cardName
        });
        if (status === 1000) {
          console.log("ospApplicationCardConfigUpdated", status, result, msg);
          this.$message.success("操作成功");
          this.closelable();
          this.getTableData();
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 删除
    async ospApplicationCardConfigRemove() {
      try {
        const {
          data: { status, result, msg },
        } = await this.$store.dispatch("ospApplicationCardConfigRemove", {
            id: this.delId
        });
        if (status === 1000) {
          console.log("ospApplicationCardConfigRemove", status, result, msg);
          this.$message.success("操作成功");
          this.noticeModal = false;
          this.getTableData();
        } else {
          this.noticeModal = false;
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 后台key更改此处 查询使用
    async businessPackageConfigListTow() {
      const {
        data: { status, result, msg },
        } = await this.$store.dispatch("businessPackageConfigList",{
            aa:1,
        });
        if (status === 1000) {
        console.log("businessPackageConfigList", status, result, msg);
        this.optionsTow = result.map((item)=>{
            return {
            noNext: false,
            value: item.id,
            label: item.packageName,
            initConfig: item.initConfig,
            isShow: true,
            }
        })
        } else {
        this.$message.error(msg);
       }
    },
    // 获取引用业务包下拉选项 新增使用
    async businessPackageConfigList(obj) {
      try {
        console.log(obj);
        const {
          data: { status, result, msg },
        } = await this.$store.dispatch("businessPackageConfigList",{
            aa:1,
            pageType: 'card'
        });
        if (status === 1000) {
          console.log("businessPackageConfigList", status, result, msg);
          this.options = result.map((item)=>{
            return {
            noNext: false,
            value: item.id,
            label: item.packageName,
            initConfig: item.initConfig,
            isManyQuote: item.isManyQuote,
            isShow: true,
            }
          })
        } else {
          this.$message.error(msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    edit(rowData) {
      setStore({
        name: "homePageRowData",
        content: rowData,
        type: "session",
      });
      this.$emit("changeComponent", "DetailsInfo");
    },
    changeComponent(rowData, page) {
      setStore({
        name: "rowData",
        content: rowData,
        type: "session",
      });
      this.$emit("changeComponent", page);
    },
    init() {
      this.$store.dispatch("dictList");
    },
    isStatus(row, key) {
      if (key === "status") {
        return row[key];
      }
    },
    handleDelete(row) {
      this.delId = row.id;
      this.noticeModal = true;
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session",
      });
    },
    // 搜索
    searchInput() {
      this.hignSearchRes = "";
      this.pageIndex = 1;
      this.getTableData();
    },
    // 重置
    resetInput() {
      this.hignSearchRes = "";
      this.pageIndex = 1;
      Object.keys(this.formInline).forEach((key) => {
        if (key === "updateTime") {
          this.formInline[key] = [];
        } else {
          this.formInline[key] = "";
        }
      });
      this.getTableData();
    },
    // 批量选中项变化
    handleSelectChange(selection) {
      console.log(selection);
      this.selectArrList = selection;
    },
    handleSelectDel() {
      if (this.selectArrList.length === 0) {
        this.$message.warning("请选择");
        return;
      }
      const idArr = this.selectArrList.map((item) => item.id);
      this.delId = idArr.join(",");
      this.noticeModal = true;
    },
    // 确认弹窗
    agreeNotice() {
      this.$store
        .dispatch("deleteVersionByIds", { ids: this.delId })
        .then((res) => {
          if (res.data.status === 1000) {
            this.$refs.otherUserId.clearSelection();
            this.getTableData();
            this.$message({
              message: "操作成功！",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
          this.noticeModal = false;
        });
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    // 返回上级
    goBack() {
      this.$emit("backHome");
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    async addPage(item) {
      await this.businessPackageConfigList()
      this.addModal = true;
      console.log(item);
      if (item) {
        this.ruleForm.id = item.id;
        this.ruleForm.addModalType = 2;
        this.ruleForm.updateTitle = item.packageName;
        this.ruleForm.cardName = item.cardName;
      } else {
        this.ruleForm.addModalType = 1;
        this.ruleForm.updateTitle = "";
      }
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 切换展示字段
    getTableList(value) {
      this.tableDataShow = value;
    },
    // 改变数据排序
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.getTableData();
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getTableData();
    },
    // 查询列表
    async getTableData() {
      let dataSortStr = this.orderConfig;
      if (Array.isArray(this.orderConfig)) {
        dataSortStr = this.orderConfig.join(",");
      }
      const startTime = this.formInline.updateTime[0]
        ? this.formInline.updateTime[0]
        : "";
      const endTime = this.formInline.updateTime[1]
        ? this.formInline.updateTime[1]
        : "";
      this.loading = true;
      const serviceList = await this.$store.dispatch("ospApplicationCardConfigPage", {
        // versionInfo: {
        //   appType: this.formInline.appType,
        //   version: this.formInline.version,
        //   versionCode: this.formInline.versionCode,
        //   updateType: this.formInline.updateType,
        //   referencePackage: this.formInline.referencePackage,
        //   cardName: this.formInline.cardName,
        //   updateTimeStart: startTime,
        //   updateTimeEnd: endTime,
        // },
        packageId: this.formInline.referencePackage,
        cardName: this.formInline.cardName,
        // dataSortStr: dataSortStr, //数据排序
        // advancedSearch: this.hignSearchRes,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
      this.loading = false;
      const { result } = serviceList.data;
      if (serviceList.data.status === 1000) {
        if (result.data.length !== 0) {
          this.tableData = result.data;
          this.totalNum = Number(result.total);
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex -= 1;
            this.getTableData();
          } else {
            this.tableData = [];
            this.totalNum = 0;
          }
        }
      } else {
        this.tableData = [];
        this.totalNum = 0;
      }
    },
    getlable(row, key) {
      // console.log(row, key)
      let value = row[key];
      switch (key) {
        case "appType":
          if (row[key] == 1) {
            value = "iOS";
          } else if (row[key] == 2) {
            value = "安卓";
          } else {
            value = "无";
          }
          break;
        case "updateType":
          if (row[key] == 1) {
            value = "强制更新";
          } else if (row[key] == 2) {
            value = "推荐更新";
          } else {
            value = "无";
          }
          break;
        default:
          value = row[key];
          break;
      }
      return value;
    },
    download(src) {
      window.open(src);
    },
  },
  computed: {
    addBtmDisable() {
      if (this.ruleForm.fields.length < 10) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

  <style lang="scss">
.cardsConfigNew{
    .el-table__body-wrapper  {
        height: calc(100vh - 193px) !important;
    }
}
.tableThree-heightOth {
  .el-table__body-wrapper {
    .tableThree-height-shu {
      display: inline-block;
      padding: 0 4px;
      position: relative;
      .shu-item {
        position: absolute;
        width: 1px;
        height: 12px;
        background-color: #d4d4d7;
        display: inline-block;
        top: -10px;
      }
    }
  }
  .bigImg {
    color: #2d8cf0;
    cursor: pointer;
  }
  .redCorlo {
    color: #ff4d4f;
  }
  .greenCorlo {
    color: #33cc99;
  }
}
.serviceDialog {
  text-align: center;
  img {
    max-width: 100%;
  }
  .el-dialog__body {
    padding: 10px 0 !important;
  }
}
.el-range-editor.el-input__inner {
  width: 216px;
}
.list-addField-delete {
  display: inline-block;
  height: 28px;
  line-height: 28px;
  text-align: left;
  .el-button {
    width: 16px;
    height: 16px;
    padding: 0;
    color: #ff4d4f;
    border: 1px solid #ff4d4f;
    vertical-align: middle;
  }
}
</style>
